import React from 'react'
import PropTypes from 'prop-types'
import { useQuery } from 'react-query'
import { Notification } from '@offerzen/pinata'

import styles from './styles'
import MatchingList from './MatchingList'
import NonMatchingList from './NonMatchingList'
import MatchingRequirementsSkeleton from './MatchingRequirementsSkeleton'
import { getPositionMatchingRequirements } from './api'

const MatchingRequirements = ({ jobId, candidateProfileId }) => {
  const { data, isLoading, isError } = useQuery(['positionMatchingRequirements', jobId, candidateProfileId], () => {
    return getPositionMatchingRequirements({ positionId: jobId, candidateProfileId })
  })

  if (isError) {
    return (
      <Notification theme="error">
        <div role="alert">Something went wrong.</div>
      </Notification>
    )
  }

  if (isLoading || !data) {
    return <MatchingRequirementsSkeleton />
  }

  const matchingRequirementsData = data.matchingRequirements

  const matchingRequirements = Object.keys(matchingRequirementsData).filter(requirement => matchingRequirementsData[requirement])
  const nonMatchingRequirements = Object.keys(matchingRequirementsData).filter(requirement => !matchingRequirementsData[requirement])
  const totalRequirementsCount = nonMatchingRequirements.length + matchingRequirements.length

  return (
    <>
      <h4 className={styles.text}>
        Your profile matches {matchingRequirements.length}/{totalRequirementsCount} requirements for this job.
      </h4>

      <If condition={matchingRequirements.length > 0}>
        <MatchingList matchingRequirements={matchingRequirements} />
      </If>

      <If condition={nonMatchingRequirements.length > 0}>
        <h4 className={styles.text}>You don&apos;t match</h4>
        <NonMatchingList nonMatchingRequirements={nonMatchingRequirements} />
      </If>
    </>
  )
}

MatchingRequirements.propTypes = {
  jobId: PropTypes.string,
  candidateProfileId: PropTypes.string,
}

export default MatchingRequirements
